import axios from 'axios';

const API_BASE = "";

export const syncCluster = (clusterName) =>
    axios.post(`${API_BASE}/api/sync/${clusterName}`);

export const getFirestoreStatus = (cluster) =>
    axios.get(`${API_BASE}/api/firestore-status/${cluster}`);
export const getPlvStatus = (clusterName) => axios.get(`${API_BASE}/api/plv-status/${clusterName}`);

export const publishIncident = (incident) =>
    axios.post(`${API_BASE}/api/incidents/publish`, incident);

export const unpublishIncident = (incident) =>
    axios.post(`${API_BASE}/api/incidents/unpublish`, { id: incident.id });

export const addCustomIncident = (incidentData) =>
    axios.post(`${API_BASE}/api/incidents/custom`, incidentData);

export const updateIncident = (incidentData) =>
    axios.put(`${API_BASE}/api/incidents/${incidentData.id}`, incidentData);

export const erasePastIncident = (incident) =>
    axios.delete(`${API_BASE}/api/incidents/past/erase`, { data: { id: incident.id } });

export const getActiveIncidents = () =>
    axios.get(`${API_BASE}/api/incidents/active`);

export const getArchivedIncidents = () =>
    axios.get(`${API_BASE}/api/incidents/archived`);

export const getClusters = () => axios.get(`${API_BASE}/api/clusters`);
export const addCluster = (clusterName) => axios.post(`${API_BASE}/api/clusters`, { name: clusterName });
export const removeCluster = (clusterName) => axios.delete(`${API_BASE}/api/clusters/${clusterName}`);

export const addMaintenance = (maintenanceData) =>
    axios.post(`${API_BASE}/api/maintenance`, maintenanceData);

export const getActiveMaintenance = () =>
    axios.get(`${API_BASE}/api/maintenance/active`);

export const getArchivedMaintenance = () =>
    axios.get(`${API_BASE}/api/maintenance/archived`);

export const updateMaintenance = (maintenanceData) =>
    axios.put(`${API_BASE}/api/maintenance/${maintenanceData.id}`, maintenanceData);

export const archiveMaintenance = (maintenanceID) =>
    axios.post(`${API_BASE}/api/maintenance/archive/${maintenanceID}`);

export const eraseArchivedMaintenance = (maintenanceID) =>
    axios.delete(`${API_BASE}/api/maintenance/archived/erase`, { data: { id: maintenanceID } });

export const setClusterStatus = (clusterName, statusData) =>
    axios.put(`${API_BASE}/api/clusters/${clusterName}/status`, statusData);
